<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppSelect from './AppSelect';

@Component
export default class AppMultipleSelect extends AppSelect {
  /**
   * 複数選択を有効にする
   */
  get multiple () {
    return true;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/select/AppMultipleSelect.vue